module.exports = __webpack_public_path__ + "img/infobtn.8f836d77.png";